/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Calendar16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <g fill={vars.bdlGray50} fillRule="evenodd">
            <path d="M13.436 0c.892 0 1.215.093 1.54.267.327.174.583.43.757.756.174.326.267.65.267 1.54v10.873c0 .892-.093 1.215-.267 1.54-.174.327-.43.583-.756.757-.326.174-.65.267-1.54.267H2.563c-.892 0-1.215-.093-1.54-.267a1.817 1.817 0 01-.757-.756C.093 14.65 0 14.327 0 13.437V2.563c0-.892.093-1.215.267-1.54.174-.327.43-.583.756-.757C1.35.093 1.673 0 2.563 0h10.873zM13 4H3a1 1 0 00-1 1v8a1 1 0 001 1h10a1 1 0 001-1V5a1 1 0 00-1-1z" />
            <g transform="translate(3 5.5)">
                <rect width={1.5} height={1.5} x={2.833} rx={0.5} />
                <rect width={1.5} height={1.5} x={5.667} rx={0.5} />
                <rect width={1.5} height={1.5} x={8.5} rx={0.5} />
                <rect width={1.5} height={1.5} y={2.5} rx={0.5} />
                <rect width={1.5} height={1.5} x={2.83} y={2.5} rx={0.5} />
                <rect width={1.5} height={1.5} x={5.67} y={2.5} rx={0.5} />
                <rect width={1.5} height={1.5} x={8.5} y={2.5} rx={0.5} />
                <rect width={1.5} height={1.5} y={5} rx={0.5} />
                <rect width={1.5} height={1.5} x={2.83} y={5} rx={0.5} />
            </g>
        </g>
    </AccessibleSVG>
);

export default Calendar16;
